import * as React from 'react';
import { styled } from '@mui/material/styles';
import { AppProvider, Navigation, Router } from '@toolpad/core/AppProvider';
import { DashboardLayout, SidebarFooterProps } from '@toolpad/core/DashboardLayout';
import { PageContainer } from '@toolpad/core';
import OverViewIcon from '../../assets/icons/overviewIcon';
import { BillingIcon, EasyCrmPurple, EwLogo, LogoutIcon, Notification, NotificationCancel, OverLay, ProfileIcon, SettingIcon, SideBarRingIcon, SignOut, SubscriptionIcon } from '../../assets/icons';
import { AvatarImg, easyCrmLogo, ewLogo, greenTimer, Logo, pinkTimer, purpleTimer, } from '../../assets/images';
import { Avatar, Box, Button, createTheme, IconButton, Menu, Paper, ThemeProvider, Typography } from '@mui/material';
import Billing from './components/Billing';
import Notifications from './components/Notifications';
import ManageSubscription from './components/subscription/ManageSubscription';
import Settings from './components/Settings';
import theme from '../../theme';
import Overview from './components/overview';
import SubscriptionDetails from './components/subscription/SubscriptionDetails';
import SubscriptionDetailsEasyCRM from './components/subscription/SubscriptionDetailsEasyCRM';
import Users from '../../components/Users';

const Dashboard = () => {
    const NAVIGATION: Navigation = [
        {
            icon: <OverViewIcon />,
            segment: 'overview',
            title: 'Overview',

        },

        {
            icon: <SubscriptionIcon />,
            segment: 'subscription',
            title: 'Subscription',
            pattern: 'subscription{/:orderId}*',
        },
        {
            icon: <BillingIcon />,
            segment: 'billing',
            title: 'Billing',

        },
        {
            icon: <BillingIcon />,
            segment: 'Users',
            title: 'Users',

        },
        {
            icon: <BillingIcon />,
            segment: 'Workspaces',
            title: 'Workspaces',
        },
        {
            icon: <SideBarRingIcon />,
            segment: 'notifications',
            title: 'Notifications',

        },
        {
            icon: <SettingIcon />,
            segment: 'settings',
            title: 'Settings',

        },
    ];

    const useDemoRouter = (initialPath: string): Router => {
        const [pathname, setPathname] = React.useState(initialPath);

        const router = React.useMemo(() => {
            const url = new URL(pathname, window.location.origin);
            return {
                pathname: url.pathname,
                searchParams: url.searchParams,
                navigate: (path: string | URL) => setPathname(String(path)),
            };
        }, [pathname]);

        return router;
    };

    function ToolbarActionsSearch() {
        const [anchorElNotification, setAnchorElNotification] = React.useState<null | HTMLElement>(null);
        const [anchorElOverlay, setAnchorElOverlay] = React.useState<null | HTMLElement>(null);
        const [anchorElProfile, setAnchorElProfile] = React.useState<null | HTMLElement>(null);

        const handleMenuOpenNotification = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorElNotification(event.currentTarget);
        };

        const handleMenuCloseNotification = () => {
            setAnchorElNotification(null);
        };

        const handleMenuOpenOverlay = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorElOverlay(event.currentTarget);
        };

        const handleMenuCloseOverlay = () => {
            setAnchorElOverlay(null);
        };

        const handleMenuOpenProfile = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorElProfile(event.currentTarget);
        };

        const handleMenuCloseProfile = () => {
            setAnchorElProfile(null);
        };

        return (
            <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <IconButton onClick={handleMenuOpenNotification} sx={{ "& svg rect:hover": { fill: '#f2f2f2' }, "& svg:hover path": { fill: '#0C23FF' }, padding: '0', marginRight: "12px" }}>
                            <Notification />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElNotification}
                            open={Boolean(anchorElNotification)}
                            onClose={handleMenuCloseNotification}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            sx={{ '& .MuiMenu-paper': { borderRadius: "12px !important", boxShadow: "0px 12px 20px 0px #0D0E213D" } }}
                        >
                            <Typography color='#333335' fontSize='16px' mb='19px' borderBottom='1px solid #F3F3F3' p='14px'>
                                Notifications
                            </Typography>
                            <Box display="flex" px='10px' alignItems="center" justifyContent='space-between' borderBottom='1px solid #F3F3F3' pb='11px' mb='10px'>
                                <Box display="flex">
                                    <Box borderRadius="50%" bgcolor="#26BF941A" height="40px" width="40px" display="flex" justifyContent="center" alignItems="center" marginRight="8px">
                                        <img src={greenTimer} alt="clock-img" />
                                    </Box>
                                    <Box>
                                        <Typography color='#232323' fontSize='14px' lineHeight='24px'>Plan Changed</Typography>
                                        <Typography color='#8C9097' fontSize='12px' lineHeight='18px'>Your plan has been changed to “Evergree..</Typography>
                                    </Box>
                                </Box>
                                <NotificationCancel />
                            </Box>
                            <Box display="flex" px='10px' alignItems="center" justifyContent='space-between' borderBottom='1px solid #F3F3F3' pb='11px' mb='10px'>
                                <Box display="flex">
                                    <Box borderRadius="50%" bgcolor="#E791BC1A" height="40px" width="40px" display="flex" justifyContent="center" alignItems="center" marginRight="8px">
                                        <img src={pinkTimer} alt="clock-img" />
                                    </Box>
                                    <Box>
                                        <Typography color='#232323' fontSize='14px' lineHeight='24px'>Subscription Expired</Typography>
                                        <Typography color='#8C9097' fontSize='12px' lineHeight='18px'>Your Subscription has expired</Typography>
                                    </Box>
                                </Box>
                                <NotificationCancel />
                            </Box>
                            <Box display="flex" px='10px' alignItems="center" justifyContent='space-between' borderBottom='1px solid #F3F3F3' pb='11px' mb='10px'>
                                <Box display="flex">
                                    <Box borderRadius="50%" bgcolor="#845ADF1A" height="40px" width="40px" display="flex" justifyContent="center" alignItems="center" marginRight="8px">
                                        <img src={purpleTimer} alt="clock-img" />
                                    </Box>
                                    <Box>
                                        <Typography color='#232323' fontSize='14px' lineHeight='24px'>Black Friday Deals</Typography>
                                        <Typography color='#8C9097' fontSize='12px' lineHeight='18px'>Get 50% off on all plans this season</Typography>
                                    </Box>
                                </Box>
                                <NotificationCancel />
                            </Box>
                            <Box p='16px' mt='105px' position='sticky' bottom='0' bgcolor='#FFf'>
                                <Button variant="contained" size="large" sx={{ width: '100%', textTransform: 'capitalize', backgroundColor: "#178EFC" }}>View All</Button>
                            </Box>
                        </Menu>
                        <IconButton onClick={handleMenuOpenOverlay} sx={{ "& svg rect:hover": { fill: '#f2f2f2' }, "& svg:hover path": { fill: '#0C23FF' }, padding: '0', marginRight: "12px" }}>
                            <OverLay />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElOverlay}
                            open={Boolean(anchorElOverlay)}
                            onClose={handleMenuCloseOverlay}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            sx={{ '& .MuiMenu-paper': { borderRadius: "12px !important", boxShadow: "0px 12px 20px 0px #0D0E213D" } }}
                        >
                            <Box sx={{ width: 271 }} display="flex" flexDirection="column" gap="8px">
                                <Box sx={{ '&:hover': { bgcolor: '#F3F6F8', cursor: "pointer" } }} display="flex" alignItems="center" padding="10px 20px">
                                    <EwLogo />
                                </Box>
                                <Box sx={{ '&:hover': { bgcolor: '#F3F6F8', cursor: "pointer" } }} display="flex" alignItems="center" padding="10px 20px">
                                    <EasyCrmPurple />
                                </Box>
                            </Box>
                        </Menu>
                    </Box>
                    <Box>
                        <IconButton onClick={handleMenuOpenProfile} sx={{ '&:hover': { bgcolor: '#fff' }, padding: '0' }}>
                            <Avatar alt="Remy Sharp" src={AvatarImg} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElProfile}
                            open={Boolean(anchorElProfile)}
                            onClose={handleMenuCloseProfile}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            sx={{ '& .MuiMenu-paper': { borderRadius: "12px !important", boxShadow: "0px 12px 20px 0px #0D0E213D" } }}
                        >
                            <Box display="flex" borderBottom='1px solid #F3F3F3' p='17px'>
                                <Avatar alt="Remy Sharp" src={AvatarImg} />
                                <Box ml='16px' >
                                    <Typography mb='4px' color='#0F0F0F' fontSize='16px'>Ryan Lee</Typography>
                                    <Typography color='#666666' fontSize='16px'>RyanLee091@gmail.com</Typography>
                                </Box>

                            </Box>
                            <Box display='flex' p='8px 16px' mt='8px' alignItems='center' sx={{ '&:hover': { bgcolor: '#F3F6F8' } }}>
                                <ProfileIcon></ProfileIcon>
                                <Typography color='#0F0F0F' ml='16px' fontSize='14px'>Manage Profile</Typography>

                            </Box>
                            <Box display='flex' p='8px 16px' alignItems='center' sx={{ '&:hover': { bgcolor: '#F3F6F8' } }}>
                                <SignOut></SignOut>
                                <Typography color='#0F0F0F' ml='16px' fontSize='14px'>Sign out</Typography>
                            </Box>
                        </Menu>
                    </Box>
                </Box>
            </Box>
        );
    }

    function SidebarFooter({ }: SidebarFooterProps) {
        return (
            <Box sx={{
                display: 'flex', gap: '15px', alignItems: 'center', p: '25px 20px', cursor: 'pointer', '&:hover': {
                    span: {
                        color: '#E44258'
                    },
                    svg: {
                        '& path': {
                            stroke: '#E44258'
                        }
                    },
                },
            }}>
                <LogoutIcon></LogoutIcon>
                <Typography
                    variant="caption"
                    sx={{
                        whiteSpace: 'nowrap', overflow: 'hidden', fontWeight: '500', fontSize: '16px', color: '#292D32',
                    }}
                >
                    Logout
                </Typography>

            </Box>

        );
    }

    function DemoPageContent({ pathname, navigate }: { pathname: string; navigate: (path: string | URL) => void; }) {
        console.log("pathname", pathname);

        if (pathname === "/overview") {
            return <Overview />;
        }
        else if (pathname === "/subscription") {
            return <ManageSubscription navigate={navigate} />;
        }
        else if (pathname === "/subscription/1") {
            return <ThemeProvider theme={theme} ><SubscriptionDetails navigate={navigate} /></ThemeProvider>;
        }
        else if (pathname === "/subscription/2") {
            return <ThemeProvider theme={theme} ><SubscriptionDetailsEasyCRM navigate={navigate} /></ThemeProvider>;
        }
        else if (pathname === "/billing") {
            return <ThemeProvider theme={theme} ><Billing /></ThemeProvider>;
        }
        else if (pathname === "/Users") {
            return <ThemeProvider theme={theme} ><Users/></ThemeProvider>;
        }
        else if (pathname === "/notifications") {
            return <ThemeProvider theme={theme}><Notifications /></ThemeProvider>;
        } else if (pathname === "/settings") {
            return <ThemeProvider theme={theme}><Settings /></ThemeProvider>;
        } else {
            return <p>Data is not found</p>;
        }
    }


    const router = useDemoRouter('/overview');
    console.log("router", router);

    const demoTheme = createTheme({
        cssVariables: {},
        colorSchemes: { light: true }
    });


    return (
        <Box className='dashboard-wrapper'>
            <AppProvider navigation={NAVIGATION} router={router} branding={{
                logo: (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <img src={Logo} alt="logo" />
                    </Box>
                ),
                title: '',
            }} theme={demoTheme}>
                <DashboardLayout
                    disableCollapsibleSidebar
                    sidebarExpandedWidth="96px"
                    slots={{
                        toolbarActions: ToolbarActionsSearch,
                        sidebarFooter: SidebarFooter,
                    }}
                    sx={
                        { bgcolor: '#FAFAFA' }
                    }
                >
                    <PageContainer breadcrumbs={[]} title='' sx={{
                        maxWidth: { lg: "1378px" }, "& nav[aria-label='breadcrumb']": {
                            display: "none"
                        }
                    }}>
                        <DemoPageContent pathname={router.pathname} navigate={router.navigate} />
                    </PageContainer>
                </DashboardLayout>
            </AppProvider>
        </Box >
    );
};

export default Dashboard;
